import axios from "axios";
import { DELETE_USER, GET_CODE_SUGGESTIONS, UPDATE_RESUME } from "../constants/actionTypes";
import {
  errorMessageFromResponse,
  formatName,
} from "../constants/commonFunctions";
import { store } from "../store";
import { handleErrorMessage } from "./classes";
import { handleSuccessMessage } from "./success";

export function fetchProfileDataEdit(action, token, id) {
  return async (dispatch) => {
    const headers = {
      Authorization: `Token ${token}`,
    };
    let lang = window.localStorage.getItem("i18nextLng");
    if (lang == "en-US") {
      lang = "en";
    }
    return axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/profile/${id}/?target=No_Translation`,
        { headers: headers }
      )
      .then(async(res) => {
        if (res.status >= 200 && res.status < 300) {
          const user = { ...res.data.data };
          user.profile_completion_status = res.data.profile_completion_status;
          user.resumefile = await getResumeFileFromLink(user.resume)
          user.name = formatName(user.name);
          dispatch({
            type: action,
            payload: user,
          });
          return { val: true };
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
}

export function fetchProfileDataView(action, token, id) {
  return async (dispatch) => {
    const headers = {
      Authorization: `Token ${token}`,
    };
    let lang = window.localStorage.getItem("i18nextLng");
    if (lang == "en-US") {
      lang = "en";
    }
    return axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/profile/${id}/?target=${lang}/`,
        { headers: headers }
      )
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          const user = res.data.data;
          user.name = formatName(user.name);
          dispatch({
            type: action,
            payload: user,
          });
          return { val: true };
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
}

export function updateProfileData(action, data) {
  const profileId = store.getState()?.profile?.user?.profile_id;
  return async (dispatch) => {
    const headers = {
      Authorization: `Token ${localStorage.getItem("token")}`,
    };
    return axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/profile/${profileId}/`,
        data,
        { headers: headers }
      )
      .then((res) => {
        if (res.status >= 200 && res.status < 300 && res.data.status == "1") {
          const value = Object.fromEntries(data.entries());
          dispatch({
            type: action,
            payload: value,
          });
          dispatch(handleSuccessMessage("Information updated successfully!"));
          return { val: true };
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
}

export function fetchSearchResultsData(action, url) {
  return async (dispatch) => {
    const headers = {
      Authorization: `Token ${localStorage.getItem("token")}`,
    };
    return axios
      .get(url, { headers: headers })
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          const payloadData = {
            data: res.data.data,
            nextSearch: res.data.next,
            prevSearch: res.data.previous,
          };

          dispatch({
            type: action,
            payload: payloadData,
          });
          return { val: true };
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
}

export const getEnterpriseCodes = () => {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    await axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/profile/enterprise_codes/`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      )
      .then((response) => {
        const codeSuggestions = response.data.data;
        dispatch({ type: GET_CODE_SUGGESTIONS, payload: codeSuggestions });
        return response;
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
};

export const deleteUser = () => {
  const token = localStorage.getItem("token");
  var userData = localStorage.getItem("userData");
  var parsedUserData = JSON.parse(userData);

  const data = new FormData();
  data.append("user_id", parsedUserData.user_id);
  return async (dispatch) => {
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_BASE_URL}api/v1/users/deleteUser/`,
      data: data,
      headers: {
        Authorization: `Token ${token}`,
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch({ type: DELETE_USER });
          localStorage.removeItem("userData");
          localStorage.removeItem("token");
          dispatch(handleSuccessMessage("User Deleted Successfully"));
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage("Unable to delete user: ", error));
        return error;
      });
  };
};

export function uploadResume(file) {
  const profileId = store.getState()?.profile?.user?.profile_id;
  const token = localStorage.getItem("token");

  return async (dispatch) => {
    const formData = new FormData();
    formData.append("resume", file);

    return axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/profile/${profileId}/`,
        formData,
        {
          headers: {
            Authorization: `Token ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      )
    .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          dispatch({
            type: UPDATE_RESUME,
            payload: file, 
          });
          dispatch(handleSuccessMessage("Resume uploaded successfully!"));
          return { val: true };
        }
      })
      .catch((error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
}

export async function getResumeFileFromLink(resumeUrl) {
  try {
    const response = await axios.get(resumeUrl, {
      responseType: "blob",
    });
    const filename = resumeUrl.split("/").pop().replace(/^\d+-/, "");
    const file = new File([response.data], filename, {
      type: response.data.type || "application/octet-stream",
    });

    return file; 
  } catch (error) {
    console.error("Error fetching resume file:", error);
    return null;
  }
}



//   return async (dispatch) => {
//     const formData = new FormData();
//     formData.append("file", file); // escuelajs expects key = "file"

//     return axios
//       .post("https://api.escuelajs.co/api/v1/files/upload", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       })
//       .then((res) => {
//         if (res.status >= 200 && res.status < 300) {
//           // escuelajs returns { originalname, filename, location }
//           const uploaded = res.data;

//           dispatch({
//             type: UPDATE_RESUME,
//             payload: uploaded.location, 
//           });

//           dispatch(handleSuccessMessage("Resume uploaded successfully!"));
//           return { val: true };
//         }
//       })
//       .catch((error) => {
//         dispatch(handleErrorMessage(errorMessageFromResponse(error)));
//         return error;
//       });
//   };
// }

// profile actions
export function removeResume() {
  const profileId = store.getState()?.profile?.user?.profile_id;

  return async (dispatch) => {
    const headers = {
      Authorization: `Token ${localStorage.getItem("token")}`,
    };

    const data = {
      resume: null,
    };

    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/profile/${profileId}/`,
        data,
        { headers }
      );

      if (res.status >= 200 && res.status < 300 && res.data.status === "1") {
        dispatch({
          type: "REMOVE_RESUME",
          payload: { resume: null },
        });
        dispatch(handleSuccessMessage("Resume removed successfully!"));
        return { val: true };
      }
    } catch (error) {
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      return error;
    }
  };
}

export function subscribeToDepartment(dept_mem = "", department = "") {
  return async (dispatch) => {
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    };

    const payload = {
      dept_mem: String(dept_mem),
      department: String(department),
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/profile/departmentsubscription/`,
        payload,
        { headers }
      );

      if (res.status >= 200 && res.status < 300) {
        dispatch(handleSuccessMessage("Subscribed to department successfully!"));
        return { val: true, response: res.data };
      }

      return res;
    } catch (error) {
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      return error;
    }
  };
}